export const getMediaSelectorKey = (key: string): string => {
    return `@media screen and (${key})`;
};
